import React, { useMemo } from 'react';
import { Path, resolvePath, useNavigate } from 'react-router';

import pages from 'pages';
import { MenuButton } from 'shared/components/MenuButton/MenuButton';
import { TIcon } from 'shared/components/icons/TIcon';
import { useBreakpoints } from 'hooks/useWindowSize';
import { LogoLink, MenuItems, NavigationWrapper } from './Navigation.styles';
import { EverBrightLogo } from '../icons/EverBrightLogo';
import { OnboardingNav } from './OnboardingNav/OnboardingNav';

export type MenuOptions = {
  label: string;
  link: Path | string;
  icon: TIcon;
};

type Props = {
  menuOptions: MenuOptions[];
};

function NavigationMenu({ menuOptions }: Props) {
  const navigate = useNavigate();
  return (
    <MenuItems>
      {menuOptions.map((item) => (
        <MenuButton
          key={item.label}
          label={item.label}
          Icon={item.icon}
          onClick={() => {
            navigate(item.link);
          }}
        />
      ))}
    </MenuItems>
  );
}

export function Navigation({ menuOptions, isPrePTO }: Props & { isPrePTO: boolean }) {
  const screenSize = useBreakpoints();

  const displayNav = useMemo(() => {
    if (!isPrePTO) return <NavigationMenu menuOptions={menuOptions} />;

    return screenSize === 'sm' ? null : <OnboardingNav />;
  }, [screenSize, isPrePTO, menuOptions]);

  return (
    displayNav && (
      <NavigationWrapper $isPrePTO={isPrePTO}>
        <LogoLink to={resolvePath(pages.OVERVIEW, `/${pages.DASHBOARD}`)} $isPrePTO={isPrePTO}>
          <EverBrightLogo />
        </LogoLink>
        {displayNav}
      </NavigationWrapper>
    )
  );
}

export default Navigation;
